import { round } from 'lodash'
import GaugeComponent from 'react-gauge-component'
import { Column, Row, Text } from '@/components/core'

type FluencyChartDataType = {
  value: number
  type: 'speech' | 'articulation'
}

interface FluencyChartProps {
  data: FluencyChartDataType
}

const FluencyChart = ({ data }: FluencyChartProps) => {
  const numbers = Array.from({ length: 7 }, (_, index) => index + 1)

  const value = round(data?.value, 1) || 0
  const gaugeChartValue = value * 10 - 5 || 0

  const renderGaugeChartLabels = numbers.map((number, index) => {
    const angle = 148 + (180 / 5.95) * (index + 1)
    const rotate = `rotate(${angle}deg)`
    const antiRotate = `rotate(-${angle}deg)`

    return (
      <div
        key={number}
        className="absolute transform"
        style={{
          transform: `${rotate} translate(95px) ${antiRotate}`
        }}
      >
        <Text
          size="12"
          fontWeight="bold"
          color="600"
          className="text-opacity-50"
        >
          {number}
        </Text>
      </div>
    )
  })

  return (
    <Column className="relative">
      <GaugeComponent
        className="z-10 h-full w-full"
        type="semicircle"
        value={gaugeChartValue}
        style={{
          width: 250
        }}
        maxValue={70}
        arc={{
          cornerRadius: 0,
          gradient: true,
          width: 0.2,
          subArcs: [
            { color: '#F90303', length: 0.09 },
            { color: '#F99603', length: 0.1 },
            { color: '#08AD85', length: 0.5 },
            { color: '#F99603', length: 0.5 },
            { color: '#F90303', length: 0.175 }
          ]
        }}
        pointer={{
          type: 'arrow',
          animationDelay: 0,
          width: 15,
          color: '#6A0DFD'
        }}
        labels={{
          tickLabels: {
            hideMinMax: true
          },
          valueLabel: {
            hide: true
          }
        }}
      />
      <Column className="absolute right-9 top-5 h-[150px] w-[180px] items-center justify-center space-y-2 rounded-full bg-transparent">
        {renderGaugeChartLabels}
        <Text
          size="3xl"
          fontWeight="bold"
          className="!text-electric-indigo-500"
        >
          {value}
        </Text>
        <Row className="relative w-full justify-center ">
          <Text
            transform="uppercase"
            fontWeight="bold"
            color="600"
            className="absolute left-0 text-[8px] text-opacity-50"
          >
            Slow
          </Text>
          <Text
            transform="uppercase"
            fontWeight="bold"
            color="600"
            className="absolute right-0.5 text-[8px] text-opacity-50"
          >
            Fast
          </Text>
        </Row>
      </Column>
    </Column>
  )
}

export default FluencyChart
